export const downloadPDF = (data, filename) => {
  const url = window.URL.createObjectURL(new Blob([data]))
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', filename)
  document.body.appendChild(link)
  link.click()
  return true
}

const downloadFile = (data, filename) => {
  if (
    !data ||
    !data.type ||
    (data.type !== 'application/pdf' && data.type !== 'application/zip')
  ) {
    console.error('Invalid data or content type')
    return
  }
  const blob = new Blob([data], { type: data.type })

  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename || 'Invoice_swift_copy.pdf'

  link.click()
  setTimeout(() => window.URL.revokeObjectURL(url), 0)
}

const createFilename = (isPDF, type, invRef, date) => {
  if (date) {
    date = date.replaceAll('-', '_')
  }
  if (isPDF) {
    if (type === 'settlement') {
      return `Invoice_${invRef}_${date}_settlement`
    } else if (type === 'all') {
      return `Invoice_${invRef.slice(0, 12)}_ALL`
    }
    return `Invoice_${invRef}_${date}_advance`
  }
  return `Invoice_${invRef.slice(0, 12)}_ALL`
}

// File namings
// <name of buyer>_<from date>_<to date>
// <ALL>_<from date>_<to date>
// <name of buyer>_<Last 30 Days>
// <name of buyer>_<Last 3 Months>
// <name of buyer>_<Last Financial Year>
const createSummaryFilename = (buyer, startDate, endDate, selected) => {
  buyer = buyer.split(' ').join('_').slice(0, 16)
  startDate = startDate.split('-').join('_')
  endDate = endDate.split('-').join('_')
  if (buyer === 'All buyers') {
    return `ALL_${startDate}_${endDate}`
  }
  if (selected) {
    if (selected === 'A') return `${buyer}_Last_30_Days`
    if (selected === 'B') return `${buyer}_Last_3_Months`
    if (selected === 'C') return `${buyer}_Last_Financial_Year`
  }
  return `${buyer}_${startDate}_${endDate}`
}

export default {
  downloadPDF,
  downloadFile,
  createFilename,
  createSummaryFilename
}
